import React from 'react'
import './Header.scss'

const Header = () => {
  return (
    <div className='header'>
    
    <div className='left'>
   vU<span>p</span>Pdf
    </div>

    <div className='center'>
    Convert Any Pdf
    </div>

    <div className='right'>
    <li>Log In</li>
    <li>Explore Tools</li>
    </div>

    
    </div>
  )
}

export default Header